import axios from "axios";
import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Form from "../../../components/commonComponent/Form";
import { MODE } from "../../../constants/SiteConstants";

const API_URL = process.env.REACT_APP_API_URL;

const fields = [
  {
    label: "Name",
    name: "fullName",
    placeholder: "Enter your name",
    required: true,
  },
  {
    label: "Email",
    name: "email",
    placeholder: "Enter email",
    type: "email",
    required: true,
  },
  {
    label: "Password",
    name: "password",
    placeholder: "Enter Password",
    required: true,
  },
  {
    label: "Address",
    name: "address",
    placeholder: "Enter address",
    required: true,
  },
  {
    label: "Phone Number",
    name: "phoneNumber",
    placeholder: "Enter phone number",
    required: true,
  },
];

const AddUser = () => {
  const navigate = useNavigate();

  const handleSubmit = async (formData) => {
    try {
      await axios.post(`${API_URL}/users/addUser`, formData);
      toast.success("Data added successfully", {
        autoClose: 1000,
      });
      navigate("/userManagement");
    } catch (error) {
      if (error.message === "Email already exists") {
        toast.error("Email already exists", {
          autoClose: 1000,
        });
      } else {
        toast.error("Error adding data", {
          autoClose: 1000,
        });
      }
    }
  };

  return (
    <div className="form-wrapper shadow-md">
      <div className="form-header">
        <h3 className="font-medium text-black border-b border-gray-300 pb-2 w-full">
          Add User
        </h3>
        <button
          className="form-close-btn"
          onClick={() => navigate("/userManagement")}
        >
          &times;
        </button>
      </div>
      <Form mode={MODE.ADD} onSubmit={handleSubmit} fields={fields} />
    </div>
  );
};

export default AddUser;
